import {
    API
} from "../http-common";

const RESOURCE_NAME = "/Values";

export default {
    Professions() {
        return API.get(RESOURCE_NAME + "/Professions");
    },
    Countries() {
        return API.get(RESOURCE_NAME + "/Countries");
    },
    Nationalities() {
        return API.get(RESOURCE_NAME + "/Nationalities");
    },
    Contact(data) {
        return API.post("/Common/SendContactMessage", data);
    },
    FileTypes() {
        return API.get(RESOURCE_NAME + "/FileTypes");
    },
    BICfromIBAN(country, bankCode) {
        return API.get(
            RESOURCE_NAME + `/BICfromIBAN?country=${country}&bankCode=${bankCode}`
        );
    },
    UserDetails() {
        return API.get("/Users/Details");
    },
    SetVisitorData(data) {
        return API.post("/Users/SetVisitorData", data);
    },
    UserInfo() {
        return API.get("/Users/CurrentUserInfos");
    },
    get(id) {
        return API.get("${RESOURCE_NAME}/" + id);
    },
    create(data) {
        return API.post(RESOURCE_NAME, data);
    },
    update(id, data) {
        return API.put("${RESOURCE_NAME}/" + id, data);
    },
    delete(id) {
        return API.delete("${RESOURCE_NAME}/" + id);
    },
    AdhesionValues() {
        return API.get(RESOURCE_NAME + "/AdhesionValues");
    },
    ActivityTypes() {
        return API.get(RESOURCE_NAME + "/ActivityTypes");
    },
    FormesJuridique() {
        return API.get(RESOURCE_NAME + "/FormesJuridique");
    },
    CompanyInfo(siren) {
        return API.get(`${RESOURCE_NAME}/CompanyInfo?siren=${siren}`);
    },
    ConventionsCollectives(siren) {
        return API.get(`${RESOURCE_NAME}/ConventionsCollectives?siren=${siren}`);
    },
    ConventionByIdcc(idcc) {
        return API.get(`${RESOURCE_NAME}/ConventionByIdcc?idcc=${idcc}`);
    },
    IdccList() {
        return API.get(`${RESOURCE_NAME}/IdccList`);
    },
    HabilitationTypes() {
        return API.get(RESOURCE_NAME + "/HabilitationTypes");
    },
    ProductTypes() {
        return API.get(RESOURCE_NAME + "/ProductTypes");
    },
    DirigeantFonctions(isCommon) {
        return API.get(RESOURCE_NAME + "/DirigeantFonctions?isCommon="+isCommon);
    },
    AffiliationAccess(data) {
        data = encodeURIComponent(data);
        return API.post(`/Common/AffiliationAccess?phone=${data}`);
    },
    CheckVerificationCode(cellPhoneNum, smsCodeVal) {
        cellPhoneNum = encodeURIComponent(cellPhoneNum);
        return API.post(`/Common/CheckVerificationCode?phone=${cellPhoneNum}&code=${smsCodeVal}`);
    },
    UserRestrictions() {
        return API.get("/Common/UserRestrictions");
    },
    ActivitySectors() {
        return API.get(RESOURCE_NAME + "/ActivitySectors");
    },
    TeamMahaka() {
        return API.get(RESOURCE_NAME + "/TeamMahaka");
    },
};